export const SET_SSR_PAGE = 'SET_SSR_PAGE';
export const SET_DOMAIN = 'SET_DOMAIN';
